const configs = {
  localDevelopment: {
    graphql: {
      url: 'http://localhost:4444/graphql',
    },
  },
  development: {
    graphql: {
      url: 'https://sparc-server-dev.herokuapp.com/graphql',
    },
  },
  production: {
    graphql: {
      url: 'https://sparc-server-dev.herokuapp.com/graphql',
    },
  },
}

const env = process.env.REACT_APP_NODE_ENV || process.env.NODE_ENV
export default configs[env]
